var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.98634 8.46299L8.79403 11.2322C8.93534 11.3351 9.09907 11.3873 9.26322 11.3873C9.4003 11.3873 9.53737 11.3513 9.66261 11.2779C9.93761 11.1173 10.1094 10.8048 10.1094 10.4642L10.1094 4.92576C10.1094 4.58514 9.93761 4.27268 9.66261 4.11207C9.53738 4.03868 9.4003 4.00268 9.26322 4.00268C9.09907 4.00268 8.93534 4.05484 8.79361 4.15776L4.98591 6.92699C4.75068 7.09822 4.60938 7.38622 4.60938 7.69499C4.60938 8.00376 4.75068 8.29176 4.98634 8.46299Z",
    fill: "#858A94"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.8df6f09b5dce03a163713583890855b7.svg";
export { ForwardRef as ReactComponent };